/* eslint-disable no-restricted-globals */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';
import { Container } from '@material-ui/core';
import { Header, MainNavigation } from 'components';

import { useAuth } from 'hooks/useAuth';
import { IMainProps } from './types';
import useStyles from './style';

const Main = ({ children, routes }: IMainProps) => {
  const { signOut, account } = useAuth();
  const classes = useStyles({ maxWidth: '97%' });

  const location = useLocation();

  const parentRoute = routes.find(x =>
    matchPath(location.pathname, {
      path: x.path,
      exact: true,
      strict: false,
    }),
  );

  const childRoute =
    routes &&
    routes
      .find(x => x.children?.some(y => y.path === location.pathname))
      ?.children?.find(z => z.path === location.pathname);

  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);

  const onClickMenuButton = React.useCallback(() => {
    setOpenDrawer(open => !open);
  }, []);

  const onCloseDrawer = React.useCallback(() => {
    setOpenDrawer(false);
  }, []);

  // eslint-disable-next-line no-unused-vars
  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setOpenDrawer(open);
    };

  return (
    <div className={classes.root}>
      <Header
        username={account ? account.name! : ''}
        onClickMenuButton={onClickMenuButton}
        onClickLogout={signOut}
        pageTitle={parentRoute?.meta.title || childRoute?.meta.title}
      />
      <div className={classes.body} role="presentation">
        <MainNavigation
          openDrawer={openDrawer}
          onCloseDrawer={onCloseDrawer}
          routes={routes}
          toggleDrawer={toggleDrawer}
        />
        <Container className={classes.container}>{children}</Container>
      </div>
    </div>
  );
};

export default Main;
